import { useState } from "react";
import { X, Send } from "lucide-react";
import { CONTACT } from "@/data/site";

const WhatsAppIcon = ({ size = 26 }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M16.001 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.257.59 4.46 1.71 6.402L3.2 28.8l6.57-1.72a12.74 12.74 0 0 0 6.23 1.62h.005c7.06 0 12.8-5.74 12.8-12.8 0-3.42-1.332-6.635-3.75-9.052A12.71 12.71 0 0 0 16.001 3.2zm0 23.04h-.004a10.62 10.62 0 0 1-5.41-1.48l-.388-.23-4.02 1.053 1.072-3.92-.253-.402a10.6 10.6 0 0 1-1.626-5.66c0-5.867 4.774-10.64 10.644-10.64a10.57 10.57 0 0 1 7.522 3.12 10.57 10.57 0 0 1 3.116 7.526c0 5.868-4.774 10.643-10.643 10.643zm5.834-7.968c-.32-.16-1.892-.933-2.185-1.04-.293-.107-.507-.16-.72.16-.213.32-.826 1.04-1.013 1.253-.187.213-.373.24-.693.08-.32-.16-1.35-.498-2.572-1.587-.95-.848-1.592-1.895-1.779-2.215-.186-.32-.02-.493.14-.653.144-.143.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.735-.986-2.375-.26-.624-.523-.539-.72-.549l-.613-.011c-.213 0-.56.08-.853.4-.293.32-1.12 1.094-1.12 2.669 0 1.574 1.146 3.095 1.306 3.308.16.213 2.256 3.445 5.466 4.83.764.33 1.36.527 1.824.674.766.244 1.464.21 2.016.127.615-.092 1.892-.773 2.159-1.52.267-.746.267-1.386.187-1.52-.08-.133-.293-.213-.613-.373z" />
  </svg>
);

export const WhatsAppChat = () => {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("Hallo Andrea, ich interessiere mich für einen Termin.");

  const send = () => {
    const text = encodeURIComponent(msg || "Hallo Andrea, ich hätte gerne einen Termin.");
    window.open(`${CONTACT.whatsappHref}?text=${text}`, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="fixed z-40 bottom-6 right-6 flex flex-col items-end gap-3">
      {open && (
        <div
          data-testid="whatsapp-panel"
          className="w-[19rem] sm:w-80 rounded-2xl overflow-hidden shadow-[0_20px_50px_-15px_rgba(0,0,0,0.4)] ring-1 ring-black/5 bg-white animate-in"
        >
          <div className="bg-[#075E54] text-white px-4 py-3 flex items-center gap-3">
            <span className="h-9 w-9 rounded-full bg-white/15 flex items-center justify-center">
              <WhatsAppIcon size={20} />
            </span>
            <div className="leading-tight">
              <p className="text-sm font-medium">Andrea Rauh-Ambros</p>
              <p className="text-[11px] text-white/70">Antwortet i. d. R. innerhalb weniger Stunden</p>
            </div>
            <button data-testid="whatsapp-close" onClick={() => setOpen(false)} className="ml-auto text-white/80 hover:text-white" aria-label="Schließen">
              <X size={18} />
            </button>
          </div>
          <div className="px-4 py-4 bg-[#ECE5DD]">
            <div className="bg-white rounded-lg rounded-tl-none px-3 py-2 text-sm text-charcoal shadow-sm max-w-[85%]">
              Hallo &#128075; Wie kann ich Ihnen helfen? Schreiben Sie mir Ihre Nachricht – ich melde mich schnellstmöglich.
            </div>
            <textarea
              data-testid="whatsapp-message"
              value={msg}
              onChange={(e) => setMsg(e.target.value)}
              rows={3}
              className="mt-3 w-full rounded-lg border border-black/10 p-2.5 text-sm text-charcoal focus:outline-none focus:border-[#25D366] resize-none bg-white"
            />
            <button
              data-testid="whatsapp-send"
              onClick={send}
              className="mt-2 w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1EBE5D] text-white py-2.5 text-sm font-medium transition-colors"
            >
              <Send size={16} /> Auf WhatsApp senden
            </button>
          </div>
        </div>
      )}

      <button
        data-testid="whatsapp-launcher"
        onClick={() => setOpen((o) => !o)}
        aria-label="WhatsApp Chat öffnen"
        className="h-14 w-14 rounded-full bg-[#25D366] hover:bg-[#1EBE5D] text-white flex items-center justify-center shadow-[0_10px_30px_-8px_rgba(37,211,102,0.8)] transition-transform duration-300 hover:scale-105"
      >
        {open ? <X size={26} /> : <WhatsAppIcon size={28} />}
      </button>
    </div>
  );
};
